import React from 'react';
import { EMAIL_DE_CONTATO } from '../config/contato';

/* Peças repetidas nos dois documentos jurídicos. */

export const Email = () => <a href={`mailto:${EMAIL_DE_CONTATO}`}>{EMAIL_DE_CONTATO}</a>;

/** Tabela de fatos do sistema (cookies, permissões): `linhas` traz as células já prontas. */
export const Tabela = ({ colunas, linhas }) => (
  <div className="juridico-tabela" data-ui>
    <table>
      <thead>
        <tr>
          {colunas.map((c) => (
            <th scope="col" key={c}>
              {c}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {linhas.map((linha, i) => (
          <tr key={i}>
            {linha.map((celula, j) => (
              <td key={j}>{celula}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
